export default function(numberString) {
  return numberString.replace(/\$|,/g, '');
}
